import React, { useState } from 'react';
import axios from 'axios';
import {
  Container,
  Heading,
  FlexContainer,
  ButtonBase
} from '../../styled/common';
import { FaDownload } from 'react-icons/fa';
import { SpinningIcon } from '../../styled/common';

import AggregatedStockTable from './AggregatedStockTable';
import TechnicianAggregatedInventory from './TechnicianAggregatedInventory';

const Dashboard = ({ user }) => {
  const [selectedView, setSelectedView] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);

  const handleButtonClick = (view) => {
    setSelectedView(view);
  };

  const handleDownloadCSV = async () => {
    setIsDownloading(true);
    try {
      const response = await axios.get('/api/report/stock-fact-table', {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      const disposition = response.headers['content-disposition'];
      let filename = 'ims_stock_fact_table.csv';
      if (disposition) {
        const match = disposition.match(/filename="?(.+)"?/);
        if (match?.[1]) filename = match[1];
      }

      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('CSV download failed:', error);
      alert('Failed to download report.');
    } finally {
      setIsDownloading(false);
    }
  };

  const renderContent = () => {
    switch (selectedView) {
      case 'warehouse':
        return <AggregatedStockTable user={user} />;
      case 'technician':
        return <TechnicianAggregatedInventory user={user} />;
      default:
        return <p>Please select a view to display data.</p>;
    }
  };

  return (
    <Container>
      <Heading>Stock Management Dashboard</Heading>
      <FlexContainer justify="center" gap="20px" style={{ marginBottom: '30px' }}>
        <ButtonBase
          variant="primary"
          onClick={() => handleButtonClick('warehouse')}
          style={{ fontSize: '1rem', padding: '12px 24px' }}
        >
          Warehouse Stock
        </ButtonBase>
        {user.role === 'pm' && (
          <ButtonBase
            variant="secondary"
            onClick={() => handleButtonClick('technician')}
            style={{ fontSize: '1rem', padding: '12px 24px' }}
          >
            Technician Stock
          </ButtonBase>
        )}
        {user.role === 'pm' && (
          <ButtonBase
          variant="custom-download"
          onClick={handleDownloadCSV}
          disabled={isDownloading}
          style={{
            fontSize: '1rem',
            padding: '12px 24px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            backgroundColor: isDownloading ? '#ffc107' : '#17a2b8', // Yellow during loading, teal otherwise
            color: 'white',
            cursor: isDownloading ? 'not-allowed' : 'pointer',
          }}
        >
          {isDownloading ? (
            <>
              <SpinningIcon />
              Generating CSV...
            </>
          ) : (
            <>
              <FaDownload />
              Download Daily Stock Report
            </>
          )}
        </ButtonBase>        
        )}
      </FlexContainer>
      <div>{renderContent()}</div>
    </Container>
  );
};

export default Dashboard;
